/* eslint-disable max-len */
import React from 'react';
import { Image, Typography } from 'tfc-components';

import image from 'assets/images/home/whoweare.jpg';
import Section from 'components/organisms/Section';

const WhoWeAre: React.FC = () => (
  <Section>
    <div className="p-about_whoWeAre">
      <div className="p-about_whoWeAre_image">
        <Image imgSrc={image} alt="Who we are" ratio={411 / 309} />
      </div>
      <div className="p-about_whoWeAre_content">
        <Typography.Text extendClasses="f-28x34" fontweight="600">
          Who We Are
        </Typography.Text>
        <Typography.Text
          fontweight="600"
          extendClasses="p-about_whoWeAre_subTitle"
        >
          EVOL LABS is an AI-native venture studio
        </Typography.Text>

        <Typography.Text extendClasses="p-about_whoWeAre_text">
          We explore, test, and launch digital products powered by artificial
          intelligence — fast. Our goal isn’t to follow trends. It’s to build
          what people actually need — and kill what they don’t.
        </Typography.Text>

        <Typography.Text extendClasses="p-about_whoWeAre_text">
          Founded by builders, makers, and risk-takers, EVOL LABS operates at
          the edge of what’s possible. We combine rapid product discovery with
          real-world validation, delivering 0→1 innovation in weeks, not
          quarters.
        </Typography.Text>

        <Typography.Text
          fontweight="600"
          extendClasses="p-about_whoWeAre_subTitle p-about_whoWeAre_subTitle_italic"
        >
          We don’t build tech demos. We build real products — for real users.
        </Typography.Text>
      </div>
    </div>
  </Section>
);

export default WhoWeAre;
